<template>
	<div class="container-research">
		<h2 class="heading-2 global-box-heading">
			{{ $t('researchAdditionalScripts') }}
		</h2>
		<div
			v-for="(script, index) in researchAddScripts.cmsExpenseCategoryResearches"
			:key="index"
			class="container-script"
		>
			<ja-textarea
				v-model="script.description"
				:max-length="textAreaMaxLength"
				is-legend
				:label="$t('description')"
				:name="$t('description')"
				@blur="handleBlur"
			></ja-textarea>
			<div class="container-buttons">
				<div>
					<h2 class="heading-5">{{ $t('image') }}</h2>
					<div class="container-buttons-logos">
						<div class="select-file">
							<ja-button
								name="selectFile"
								class="small outlined"
								@click.native="openFileSelector(index)"
								>{{ $t('selectFile') }}</ja-button
							>
							<img
								v-show="script.imageBase64"
								ref="imageLogo"
								:src="script.imageBase64"
								:alt="'logo' + [index + 1]"
								class="thumbnail"
							/>
							<span v-show="!script.imageBase64">{{ $t('chooseALogo') }}</span>
							<input
								ref="fileInput"
								type="file"
								style="display: none;"
								accept=".png, .jpg, .jpeg"
								@change="validateFile($event, index)"
							/>
						</div>
					</div>
				</div>
				<div class="delete-button">
					<ja-button
						name="cancel"
						class="small outlined button-add "
						@click.native="deleteResearch(index)"
						>{{ $t('delete') }}</ja-button
					>
				</div>
			</div>
		</div>
		<div class="container-buttons">
			<ja-button
				name="save"
				class="small outlined button-add"
				@click.native="addResearch"
				>{{ $t('addAnother') }}</ja-button
			>
		</div>
		<ja-textarea
			v-model="researchAddScripts.researchDidYouKnowText"
			class="container-script"
			:max-length="textAreaMaxLength"
			is-legend
			:label="$t('researchDidYouKnowScript')"
			:name="$t('researchDidYouKnowScript')"
			@blur="handleBlur"
		></ja-textarea>
		<ja-textarea
			v-model="researchAddScripts.researchDidYouKnowSource"
			class="container-script"
			:max-length="textAreaMaxLength"
			is-legend
			:label="$t('source')"
			:name="$t('source')"
			@blur="handleBlur"
		></ja-textarea>
	</div>
</template>
<script>
import { Textarea } from '@/components/ui/form/';
import Button from '@/components/ui/Button';
import { ResizeImage } from '@/mixins';
import { cmsTextAreaMaxLength } from '@/helpers/constants';

export default {
	components: {
		jaTextarea: Textarea,
		jaButton: Button
	},
	mixins: [ResizeImage],
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			researchAddScripts: null,
			fileInfo: [],
			fileValid: [],
			textAreaMaxLength: cmsTextAreaMaxLength.RESEARCH_SCRIPTS_FORM
		};
	},
	created() {
		this.researchAddScripts = this.data;

		this.fileInfo = this.researchAddScripts.cmsExpenseCategoryResearches.map(
			() => ''
		);
		this.fileValid = this.researchAddScripts.cmsExpenseCategoryResearches.map(
			() => false
		);
	},
	methods: {
		openFileSelector(index) {
			const fileInput = this.$refs.fileInput[index];
			if (fileInput) {
				fileInput.click();
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		},
		async imageSize(file) {
			const maxLogoWidth = 250;
			const maxLogoHeight = 250;
			let fileDataURL = file;
			const resizedFile = await this.resizeImage(
				file,
				maxLogoWidth,
				maxLogoHeight
			);
			fileDataURL = await this.readFileAsync(resizedFile);

			return fileDataURL;
		},
		async validateFile(event, index) {
			const input = event.target;
			const file = input.files[0];

			const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg'];
			this.fileInfo[index] = file.name;
			if (!allowedTypes.includes(file.type)) {
				this.fileValid[index] = false;
				this.$set(this.fileValid, index, false);
				return;
			}

			const resizedDataURL = await this.imageSize(file);
			this.researchAddScripts.cmsExpenseCategoryResearches[
				index
			].imageBase64 = resizedDataURL;
			this.handleBlur();
			this.$set(this.fileValid, index, true);
		},
		addResearch() {
			const researchBase = {
				...this.researchAddScripts.cmsExpenseCategoryResearchEmpty
			};
			researchBase.expenseCategory_ID = this.researchAddScripts.expenseCategory_ID;
			this.researchAddScripts.cmsExpenseCategoryResearches.push(researchBase);
		},
		deleteResearch(index) {
			if (
				index >= 0 &&
				index < this.researchAddScripts.cmsExpenseCategoryResearches.length
			) {
				this.researchAddScripts.cmsExpenseCategoryResearches.splice(index, 1);
			}
		},
		handleBlur() {
			this.$emit('researchAddScripts', this.researchAddScripts);
		}
	}
};
</script>
<style lang="scss" scoped>
.container-research {
	margin-top: 60px;

	.container-buttons {
		display: flex;
		align-items: flex-start;
		gap: 40px;
		justify-content: center;
		position: relative;
	}
}
.container-script {
	display: flex;
	flex-direction: column;
	margin-top: 30px;

	.container-buttons {
		display: flex;
		align-items: flex-start;
		gap: 600px;
		justify-content: center;
		position: relative;

		.delete-button {
			margin-top: 48px;
		}
	}
}
.select-file {
	display: flex;
	align-items: center;
	gap: 10px;
}
.file-info {
	display: flex;
	flex-direction: column;
	gap: 5px;
}
.container-buttons-logos {
	display: flex;
}

.thumbnail {
	width: 50px;
	height: auto;
	margin: 5px;
}
.button-container {
	flex-basis: 25%;
	height: 100%;
}
.heading-5 {
	color: $font-dark;
	margin: 10px 0;
}
.button-add {
	min-width: 160px !important;
}
::v-deep label .heading-5 {
	margin-bottom: 20px;
}
</style>
